
<br>
<br>
<button pButton [disabled]="!run.openSamples" type="button" label="Approve" (click)="approve(run)"></button>
<button pButton [disabled]="!run.openSamples" type="button" label="Retest" (click)="retest(run)" style="margin-left:20px;"></button>
<br>
<br>
<iframe [srcdoc]="reportFile" style="height:4000px;width:100%;border:none;overflow:hidden;"></iframe>